import type {
  CompleteSessionResponse,
  SimulateSessionResponse,
} from '@multirx/shared/types/championship.js';
import { showChampionshipQualFinalRecap } from './showChampionshipQualFinalRecap.js';
import { showChampionshipQualMancheRecap } from './showChampionshipQualMancheRecap.js';

type QualCompletionRecaps = Pick<
  CompleteSessionResponse | SimulateSessionResponse,
  'qualMancheRecap' | 'qualFinalRecap'
>;

/** Affiche le récap manche qualif puis le classement final des qualifs si disponibles. */
export function showChampionshipQualCompletionRecaps(recaps: QualCompletionRecaps): void {
  const goSeasons = (): void => {
    window.location.hash = 'saisons';
  };
  const showFinal = (): void => {
    if (recaps.qualFinalRecap) {
      // Le dismiss du final pose déjà `#saisons` ; enchaînement manche → final OK.
      showChampionshipQualFinalRecap(recaps.qualFinalRecap);
      return;
    }
    // Manche seule (cas courant en cours de qualifs) : sans final, le Continuer
    // de la manche appelait seulement ce callback et restait bloqué sur `#course`.
    goSeasons();
  };
  if (recaps.qualMancheRecap) {
    showChampionshipQualMancheRecap(recaps.qualMancheRecap, showFinal);
  } else {
    showFinal();
  }
}
